import React from 'react';

function ColorGridWithTitle({ accentColor, title, backgroundColor, items, verticalGrid }) {

  // const resize = window.innerWidth < 1024;
    
  return (
    <section className={`${verticalGrid ? '' : 'flex flex-wrap xl:flex-nowrap'} pt-20 lg:pt-44 pb-24 px-5 sm:px-7 lg:px-20`} style={{ backgroundColor: backgroundColor }}>
      <h6 className={`relative self-start w-full lg:w-3/4 pb-6 lg:pb-12 text-5xl sm:text-7xl lg:text-9xl font-bold font-comp uppercase`} style={{ color: accentColor}}>
        {title}
        <span className={'absolute bottom-0 left-0.5 w-11 sm:w-93px lg:w-52 h-1 sm:h-5px lg:h-2.5'} style={{ backgroundColor: accentColor}}></span>
      </h6>
      <ul className={`grid ${verticalGrid ? 'grid-cols-2 lg:grid-cols-3 xl:grid-cols-fourTimes mt-12 sm:mt-14 lg:my-24' :'w-full lg:w-auto grid-cols-2 lg:grid-cols-3 xl:grid-cols-twice mt-24 xl:mt-4'} gap-y-5 sm:gap-y-11 gap-x-10 xs:gap-x-12 sm:gap-x-28 lg:gap-y-14 lg:gap-x-20 font-sans text-base-color text-xl`}>
          {items.map((item, idx) => {
              const { image, itemColor } = item.fields;
              return (
                <li className={'flex items-center justify-center rounded-lg h-12 xs:h-14 sm:h-24 md:h-28 lg:h-24 xl:h-24'} style={{ backgroundColor: itemColor }} key={idx}>
                    <img
                      src={image.fields.file.url}
                      alt={image.fields.title}
                    className={'w-full h-full object-contain object-center bg-white rounded-lg'}
                    />
                </li>
              )
          })}
          
      </ul>
    </section>
  );
}

export default ColorGridWithTitle;
